<template>
  <div>
    <v-card fill-height>
      <v-layout px-5 py-3 row wrap>
        <v-flex md12>
          <v-select
            :items="eventsList"
            v-model="selectedEvent"
            label="Select an event"
          ></v-select>
        </v-flex>
        <v-flex md12>
          <v-text-field
            textarea
            label="Message"
            rows="5"
            v-model="notificationMessage"
          ></v-text-field>
        </v-flex>
        <v-flex md12>
          <v-text-field
            textarea
            label="Recipients (comma-separated values)"
            rows="2"
            v-model="notificationRecipients"
          ></v-text-field>
        </v-flex>
        <v-flex md12>
          <v-checkbox
            label="Is active?"
            v-model="notificationIsActive"
          ></v-checkbox>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-btn
          block
          color="primary"
          @click="saveNotification"
        >Save settings</v-btn>
      </v-card-actions>
    </v-card>
    <AppEditWhatsappNotificationsDialog></AppEditWhatsappNotificationsDialog>
    <v-flex mt-5>
      <v-data-table
        :headers="tableHeaders"
        :items="items"
        hide-actions
        class="elevation-1"
        :loading="loadingInProgress"
        :no-data-text="loadingItemsText"
      >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.message }}</td>
        <td>{{ props.item.event.name }}</td>
        <td>{{ props.item.recipients_string }}</td>
        <td>{{ props.item.is_active }}</td>
        <td>{{ props.item.created_at }}</td>
        <td>{{ props.item.updated_at }}</td>
        <td class="justify-left layout px-0">
          <v-btn icon class="mx-0" @click="editElement(props.item.id)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="deleteDialog(props.item.id)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
          <confirmation-dialog ref="confirm"></confirmation-dialog>
        </td>
      </template>
    </v-data-table>
    </v-flex>
    <AppMainDialog :open="dialogOpen" :message="dialogMessage" @closedialog="dialogOpen = false"></AppMainDialog>
  </div>
</template>

<script>
  import CrudAPI from '@/api/resources/crud'
  import AppEditWhatsappNotificationsDialog from '@/components/dialogs/AppEditWhatsappNotificationsDialog'
  import resourcesMixins from '@/mixins/Resources'
  import notificationsMixins from '@/mixins/Notifications'
  import AppMainDialog from '@/components/AppMainDialog'
  import ConfirmationDialog from '@/components/dialogs/ConfirmationDialog'

  export default {
    name: 'WhatsappNotifications',
    components: { AppMainDialog, AppEditWhatsappNotificationsDialog, ConfirmationDialog },
    mixins: [ resourcesMixins, notificationsMixins ],
    data () {
      return {
        resources: 'notifications/whatsapp'
      }
    },
    methods: {
      deleteDialog (id) {
        this.$refs.confirm.open('Are you sure?', 'Delete', {}).then((confirm) => {
          this.deleteElement(id)
        })
      },
      loadListing () {
        let result = CrudAPI.dfsResourceIndex(this.resources)

        result.then(this.loadListingSuccess, this.loadListingError)
      },
      saveNotification () {
        let payload = {
          events_id: this.selectedEvent,
          recipients: this.notificationRecipients,
          message: this.notificationMessage,
          vendor: 'whatsapp',
          is_active: this.notificationIsActive
        }

        let save = CrudAPI.dfsResourceStore(this.resources, payload)

        save.then(result => {
          this.$bus.$emit('resource-added')

          this.dialogMessage = 'Successfully added'

          this.dialogOpen = true
        }, error => {
          let handle = error // eslint-disable-line
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// WhatsappNotifications.vue?4b47b6da